export default "__VITE_ASSET__C_XU0mA___"